import { render, staticRenderFns } from "./StoreLanguage.vue?vue&type=template&id=2589270a&"
import script from "./StoreLanguage.vue?vue&type=script&lang=ts&"
export * from "./StoreLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports